/**
 * @copyright Copyright (c) Open-Xchange GmbH, Germany <info@open-xchange.com>
 * @license AGPL-3.0
 *
 * This code is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with OX App Suite. If not, see <https://www.gnu.org/licenses/agpl-3.0.txt>.
 *
 * Any use of the work other than as authorized under this license or copyright law is prohibited.
 */

import DisposableView from '@/io.ox/backbone/views/disposable'
import filesAPI from '@/io.ox/files/api'
import Util from '@/io.ox/core/viewer/util'
import { createIcon } from '@/io.ox/core/components'

const AttachmentPreview = DisposableView.extend({

  initialize (options) {
    this.model = options.model
    this.$preview = options.$preview
    this.className = options.className || ''
  },

  fallback () {
    const fileType = new filesAPI.Model(this.model.toJSON()).getFileType()
    const icon = Util.CATEGORY_ICON_MAP[fileType] || Util.CATEGORY_ICON_MAP.file

    this.$preview.append(createIcon(icon).addClass(`file-type-icon file-type-${fileType} bi bi-file-earmark-${fileType} ${this.className}`))
    this.$preview.removeClass('skeleton')
  },

  imageIsLoaded (url) {
    const image = new Image()
    image.src = url
    return new Promise(resolve => {
      image.onload = () => resolve(true)
      image.onerror = () => resolve(false)
    })
  },

  loadImage (url) {
    this.imageIsLoaded(url).then(isLoaded => {
      if (isLoaded) this.$preview.css('background-image', `url(${url})`).removeClass('skeleton').addClass('generated')
      else this.fallback(this.model, this.$preview)
    })
  },

  render () {
    const url = this.model.previewUrl({ delayExecution: true })
    this.$preview.addClass('skeleton')

    if (typeof url === 'string') this.loadImage(url)
    else if (url !== null) url().then(resolvedUrl => { this.loadImage(resolvedUrl) })
    else this.fallback(this.model, this.$preview)

    return this
  }
})

export default AttachmentPreview
